import React from 'react'
import { Link } from 'react-router-dom'
function Breadcrumb(props) {
    return (
        <section className='breadcrumb-main'>
            <div className='container'>
                <div className='row'>
                    <div className='col-lg-12 col-md-12 col-sm-12'>
                         <div className='inner-box'>
                               <ul>
                                {props.title_1 && <li><Link to={`/`} style={{textDecoration:'none', color:'inherit'}}>{props.title_1}</Link></li>}
                                {props.title_2 && <li>
                                   {props.categoryheadingid ? <Link to={`/category/${props.categoryheadingid}`} style={{textDecoration:'none', color:'inherit'}}>{props.title_2}</Link> : <>{props.title_2}</> } 
                                    </li>}
                                {props.title_3 && <li>
                                    {props.subcategoryheadingid ? <Link to={`/subcategory/${props.subcategoryheadingid}`} style={{textDecoration:'none', color:'inherit'}}>{props.title_3}</Link> : <>{props.title_3}</> } 
                                    </li>}
                                {props.title_4 && <li>
                                    {props.subchildcategoryheadingid ? <Link to={`/subchildcategory/${props.subchildcategoryheadingid}`} style={{textDecoration:'none', color:'inherit'}}>{props.title_4}</Link> : <>{props.title_4}</> } 

                                    </li>}
                                {props.title_5 && <li>{props.title_5}</li>}
                               
                               </ul>
                         </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Breadcrumb
